import React from "react";
import { useState, useEffect } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink, faPencilAlt } from '@fortawesome/free-solid-svg-icons';

import { DeleteField } from "./DeleteField";
import { Field } from "../../../../types/types";


type FieldListItemProps = {
    item: Field;
    sort: any;
    actions?: boolean,
    onClick: (field: Field) => void
    dateIndexSelected?: any,
    dateSelectorParameters?: any | null, 
    dateSelected?: string | null,
};


const FieldListItem = ({dateSelected, dateSelectorParameters, item, sort, actions=true, onClick, dateIndexSelected=null}: FieldListItemProps) => {
    const [field, setField] = useState(item);
    const [showActions, setShowActions] = useState(false);

    useEffect(() => {
        setField(item);
    }, [item]);

    useEffect(() => {
        console.log("A062024 dateIndexSelected", dateIndexSelected)
    }, [dateIndexSelected]);


    const onEditClicked = (e:any) => {
        e.stopPropagation();

        if(onClick) {
            onClick(field);
        }
    }


    const onNavigateToLink = (e:any) => {
        e.stopPropagation();

        if(field && field.url) {
            window.location.href = field.url;
        }
    }


    const getSortValue = () => {
        console.log("A070324 sort", sort)
        console.log("A070324 dateIndexSelected", dateIndexSelected)
        console.log("A070324 dateSelectorParameters", dateSelectorParameters)
        console.log("A070324 dateSelected", dateSelected)
        console.log("A070324 field", field)
        if(sort) {
            const {property} = sort;
            //console.log("B031924 field", field);
            if(field.stats.hasOwnProperty(property)) {
                console.log("A070324 field.stats[property].values", field.stats[property].values);
                let selectedDateIndex = dateSelected && field.stats[property].time && field.stats[property].time.length > 0
                    ? field.stats[property].time.findIndex((date:string) => date.startsWith(dateSelected)) 
                    : field.stats[property].values.length - 1;
                //let _dateIndexSelected = dateIndexSelected ? dateIndexSelected : field.stats[property].values.length - 1;
                console.log("A070324 selectedDateIndex", selectedDateIndex);
                //selectedDateIndex = selectedDateIndex === -1 ? field.stats[property].values.length - 1 : selectedDateIndex;
                return selectedDateIndex === -1 ? "n/a" : field.stats[property].values[selectedDateIndex].toFixed(1);
            }
        }
    }


    const editMenu = () => {
        return (
            <div className="d-flex" style={{ position:"absolute", right:"5px", top:"5px", height:"30px"}}>
                { field.url &&
                <div title="Navigate to dashboard" onClick={(e) => onNavigateToLink(e)} className="text-sm align-items-center bg-light d-flex flex-lg-row justify-content-center rounded-circle text-black ml-2" style={{width: '25px', height: '25px'}}>
                    <FontAwesomeIcon icon={faLink} />
                </div>
                }
                <div title="Edit" onClick={(e) => onEditClicked(e)} className="text-sm align-items-center bg-success d-flex flex-lg-row justify-content-center rounded-circle text-white ml-2" style={{width: '25px', height: '25px'}}>
                    <FontAwesomeIcon icon={faPencilAlt} />
                </div>
                <DeleteField fieldId={field.id!} />
            </div>
        );
    }

    return (
        <div key={field.id} id={`field_${field.id}`} className="align-items-center d-flex text-dark"
            onMouseEnter={() => setShowActions(true)}
            onMouseLeave={() => setShowActions(false)}
            >
            <div className="d-flex flex-column w-100">
                <div className="d-flex justify-content-between">
                    <div className="text-xs text-muted" style={{fontSize:'0.65rem', lineHeight:'0.75rem'}}>{field.farm? field.farm.name : ""}</div>
                </div>
                <div className="d-flex justify-content-between">
                    <h5 className="font-weight-bold text-base text-truncate mb-0">{field.name}</h5>
                    { actions && showActions && editMenu() }
                    <div className="text-base-lg" title={sort ? sort.title : ""}>{getSortValue()}</div>
                </div>
                <div className="d-flex justify-content-between">
                    <div className="text-sm text-muted">
                        <span className="text-capitalize">{field.crop ? field.crop.name : 'na - b'}</span> <span className="mx-1">&bull;</span>{field.area.toFixed(0)} ac
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FieldListItem;
